import React, { useState } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Intro from "./pages/Intro";
import Skills from "./pages/Skills";
import ContactUs from "./pages/ContactUs";
import Projects from "./pages/Projects";

import NotFound from "./components/NotFound";
import Navbar from "./components/Navbar";
import MobileNav from "./components/MobileNav";

function App() {
  const [openNav, setOpenNav] = useState(false);
  const toggleNav = () => {
    setOpenNav(!openNav);
  };
  return (
    <Router>
      <div className="App">
        <Navbar toggleNav={toggleNav} navOpen={openNav} />
        <div className="wrapper">
          {openNav && (
            <div className="mobile_nav">
              <MobileNav closeNav={toggleNav} />
            </div>
          )}
          <div className="main_body">
            <Switch>
              <Route exact path="/" component={Intro} />
              <Route path="/skills" component={Skills} />
              <Route path="/projects" component={Projects} />
              <Route path="/contactus" component={ContactUs} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
